import type { ReactNode } from 'react';
import styled from 'styled-components';

import { gradient } from '@/styles/shared';

export const PromobarWrapper = styled.div`
  width: 100%;
  padding: 10px;
  color: ${({ theme }) => theme.palette.background};
  text-decoration: none;
  font-weight: 400;
  text-align: center;
  display: inline-block;
  font-size: 11px;
  -webkit-text-size-adjust: 100%;
  position: sticky;
  top: 0;
  z-index: 999;
  background: ${gradient};
  transition: all 0.4s ease;

  @media ${({ theme }) => theme.media.tablet} {
    font-size: 12px;
  }
`;

export const ArrowIcon = styled.svg<{
  children?: ReactNode;
  viewBox?: string;
}>`
  width: 18px;
  height: 7px;
  flex-shrink: 0;
  fill: none;
  vertical-align: middle;
  margin-left: 8px;
  transform: translateY(-1px);
`;
